<template>
  <receive-coupon-popup
    :showCouponPopup="showCouponPopup"
    :showSeriesPopup="showSeriesPopup"
    :seriesList="seriesList"
    :seriesSelected="seriesSelected"
    :showAgreement="showAgreement"
    :agreementChecked="agreementChecked"
    @clickClose="hideCouponSeriesPopup"
    @clickSeries="changeShowSeriesPopup"
    @selectSeries="selectSeries"
    @changeAgreementChecked="changeAgreementChecked"
    @gotoAgreement="gotoAgreement"
    @clickReceive="clickReceive"
  ></receive-coupon-popup>
</template>

<script>
import ReceiveCouponPopup from '@this/components/Popup/ReceiveCoupon';
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('coupon', [
      'showCouponPopup',
      'showSeriesPopup',
      'seriesList',
      'seriesSelected',
      'agreementChecked',
      'showAgreement',
    ]),
  },
  methods: {
    ...mapActions('coupon', [
      'hideCouponSeriesPopup',
      'changeShowSeriesPopup',
      'selectSeries',
      'changeAgreementChecked',
      'gotoAgreement',
      'clickReceive',
    ]),
  },
  components: {
    ReceiveCouponPopup,
  },
};
</script>
